import axios from 'axios';
import { cloudflareAPI } from '@/features/dooh/r2/r2API';

export const R2_BASE_URL =
  import.meta.env.VITE_R2_BASE_URL ||
  'https://pub-33af99c61b3f46beb6364ed24e5c2a05.r2.dev';

export class R2UploadService {
  static async uploadFiles(
    files: { file: File; storagePath: string }[]
  ): Promise<string[]> {
    if (files.length === 0) return [];

    const batchSize = 5;
    const publicUrls: string[] = new Array(files.length);

    for (let i = 0; i < files.length; i += batchSize) {
      const batch = files.slice(i, i + batchSize);

      const signedUrls = await cloudflareAPI.getUploadLinks(
        batch.map(({ file, storagePath }) => ({
          path: storagePath,
          contentType: file.type || 'application/octet-stream',
        }))
      );

      await Promise.all(
        batch.map(async ({ file }, batchIdx) => {
          const { url, key } = signedUrls[batchIdx];

          try {
            await axios.put(url, file, {
              headers: {
                'Content-Type': file.type || 'application/octet-stream',
              },
            });
            publicUrls[i + batchIdx] = `${R2_BASE_URL}/${key}`;
          } catch (err) {
            console.error(`Error uploading file "${file.name}":`, err);
            throw err;
          }
        })
      );
    }

    return publicUrls;
  }

  static validateFile(
    file: File,
    options: { maxSize?: number; allowedTypes?: string[] } = {}
  ): { isValid: boolean; error?: string } {
    const { maxSize = 10 * 1024 * 1024, allowedTypes = [] } = options;

    if (file.size > maxSize) {
      return {
        isValid: false,
        error: `File size must be less than ${Math.round(maxSize / (1024 * 1024))}MB`,
      };
    }

    if (allowedTypes.length > 0 && !allowedTypes.includes(file.type)) {
      return {
        isValid: false,
        error: `File type must be one of: ${allowedTypes.join(', ')}`,
      };
    }

    return { isValid: true };
  }
}

export default R2UploadService;
